import { KeywordResponse, KeywordStatus } from '../../../models/monitor/KeywordResponse';
import { client } from '../../apiClient';
import { FirmData } from '../../../models/monitor/FirmData';
import { PROMPT_ENDPOINT } from '../prompt/PromptService';
import { KeywordsData } from '../../../models/tags/TagsResponse';

export const KEYWORDS_ENDPOINT = '/monitor/keywords';

export const getKeywordsData = async (id: string): Promise<KeywordResponse[]> => {
  return client(true, true)
    .get<KeywordResponse[]>(`${KEYWORDS_ENDPOINT}/list/${id}`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const getCommonKeywordsWithTags = async (projectId: number): Promise<KeywordResponse[]> => {
  const { data } = await client(true, true).get<KeywordResponse[]>(
    `${KEYWORDS_ENDPOINT}/common-keywords-tags/${projectId}`
  );
  return data;
};

export const getCommonKeywords = async (projectId: number): Promise<KeywordsData[]> => {
  const { data } = await client(true, true).get<KeywordsData[]>(
    `${KEYWORDS_ENDPOINT}/common-keywords/${projectId}`
  );
  return data;
};

export const regenerateKeywords = async (id: number): Promise<KeywordResponse[]> => {
  return client(true, true)
    .get<KeywordResponse[]>(`${KEYWORDS_ENDPOINT}/regenerate-keywords/${id}`)
    .then((response) => response.data)
    .catch((error) => error);
};

export const getProjectKeywords = async (projectId: number): Promise<KeywordResponse[]> => {
  const { data } = await client(true, true).get<KeywordResponse[]>(
    `${KEYWORDS_ENDPOINT}?projectId=${projectId}`
  );
  return data;
};

export const bulkUpdateKeywordStatus = async (
  keywordIds: number[],
  status: KeywordStatus
): Promise<{ updated: number; failed: number }> => {
  const { data } = await client(true, true).patch<{ updated: number; failed: number }>(
    `${KEYWORDS_ENDPOINT}/bulk-status`,
    { keywordIds, status }
  );
  return data;
};

export const updateKeywordStatus = async (
  keywordId: number,
  status: KeywordStatus
): Promise<{ success: boolean }> => {
  const { data } = await client(true, true).patch<{ success: boolean }>(
    `${KEYWORDS_ENDPOINT}/${keywordId}/status`,
    { status }
  );
  return data;
};

export const updateKeywords = async (id: string, firmData: FirmData): Promise<KeywordResponse> => {
  if (!firmData) {
    throw Error('Keyword is empty');
  }

  const keywordData = { keyword: firmData.type };
  return client(true, true)
    .post<KeywordResponse>(`${PROMPT_ENDPOINT}/update-keyword/${id}`, keywordData)
    .then((response) => response.data)
    .catch((error) => error);
};
